var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row d-print-none" }, [
      _c("div", { staticClass: "content-header-left col-md-7 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v("Monnify Reconciliation")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v(_vm._s(_vm.trans("general.home")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "breadcrumb-item active" }, [
                  _vm._v("Rejected Payment Report")
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-5 col-12 d-md-block d-none"
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-secondary btn-sm mr-1",
              on: { click: _vm.printReport }
            },
            [_c("i", { staticClass: "feather icon-printer" }), _vm._v(" Print")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-outline-primary btn-sm mr-1",
              on: { click: _vm.exportCsv }
            },
            [_c("i", { staticClass: "feather icon-download" }), _vm._v(" CSV")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-outline-danger btn-sm mr-1",
              on: { click: _vm.exportPdf }
            },
            [_c("i", { staticClass: "feather icon-file-text" }), _vm._v(" PDF")]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "alert alert-warning d-print-none" }, [
        _vm._v(
          "\n            This report is read-only. It does not update payments, invoices, payment items, or receipts.\n        "
        )
      ]),
      _vm._v(" "),
      _vm.batchMeta
        ? _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3 col-sm-6 mb-1" }, [
                  _c("span", { staticClass: "text-muted d-block" }, [
                    _vm._v("Original filename")
                  ]),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.batchMeta.original_filename || "-"))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3 col-sm-6 mb-1" }, [
                  _c("span", { staticClass: "text-muted d-block" }, [
                    _vm._v("Imported row count")
                  ]),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.batchMeta.imported_row_count || 0))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3 col-sm-6 mb-1" }, [
                  _c("span", { staticClass: "text-muted d-block" }, [
                    _vm._v("Batch reference")
                  ]),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.batchMeta.batch_reference || "-"))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3 col-sm-6 mb-1" }, [
                  _c("span", { staticClass: "text-muted d-block" }, [
                    _vm._v("Upload date")
                  ]),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.batchMeta.uploaded_at || "-"))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("span", { staticClass: "text-muted d-block" }, [
                    _vm._v("File hash")
                  ]),
                  _vm._v(" "),
                  _c("code", { staticClass: "text-break" }, [
                    _vm._v(_vm._s(_vm.batchMeta.file_hash || "-"))
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPermission("upload-monnify-reconciliation")
        ? _c("div", { staticClass: "card d-print-none" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row align-items-end" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("input", {
                    ref: "file",
                    staticClass: "form-control",
                    attrs: { type: "file", accept: ".csv,.txt" }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { disabled: _vm.uploading },
                      on: { click: _vm.uploadFile }
                    },
                    [
                      _c("i", { staticClass: "feather icon-upload" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.uploading
                              ? "Uploading..."
                              : "Upload and Analyze"
                          ) +
                          "\n                        "
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card d-print-none" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title mb-0" }, [
            _vm._v(_vm._s(_vm.trans("general.filter")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Reconciliation batch")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.batch_id,
                      expression: "filters.batch_id"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filters,
                        "batch_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("All Batches")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.batches.data, function(batch) {
                    return _c(
                      "option",
                      { key: batch.id, domProps: { value: batch.id } },
                      [
                        _vm._v(
                          _vm._s(
                            batch.original_filename || batch.batch_reference
                          )
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Institution / School")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.institutionSearch,
                    expression: "institutionSearch"
                  }
                ],
                staticClass: "form-control mb-50",
                attrs: { placeholder: "Search institution" },
                domProps: { value: _vm.institutionSearch },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.institutionSearch = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.institution_id,
                      expression: "filters.institution_id"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filters,
                        "institution_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("All Institutions")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.filteredInstitutionOptions, function(institution) {
                    return _c(
                      "option",
                      {
                        key: institution.id,
                        domProps: { value: institution.id }
                      },
                      [_vm._v(_vm._s(institution.name))]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Student / Payer")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filters.payer,
                    expression: "filters.payer"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.filters.payer },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.filters, "payer", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Invoice number")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filters.invoice_no,
                    expression: "filters.invoice_no"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.filters.invoice_no },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.filters, "invoice_no", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Transaction reference")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filters.transaction_reference,
                    expression: "filters.transaction_reference"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.filters.transaction_reference },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.filters,
                      "transaction_reference",
                      $event.target.value
                    )
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Payment status")]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.payment_status,
                      expression: "filters.payment_status"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filters,
                        "payment_status",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("All")]),
                  _c("option", [_vm._v("success")]),
                  _c("option", [_vm._v("paid")]),
                  _c("option", [_vm._v("pending")]),
                  _c("option", [_vm._v("failed")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Classification")]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.classification,
                      expression: "filters.classification"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filters,
                        "classification",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("All")]),
                  _vm._l(_vm.classifications, function(item) {
                    return _c(
                      "option",
                      { key: item, domProps: { value: item } },
                      [_vm._v(_vm._s(item))]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Match status")]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.match_status,
                      expression: "filters.match_status"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filters,
                        "match_status",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("All")]),
                  _c("option", [_vm._v("matched")]),
                  _c("option", [_vm._v("diagnostic_match")]),
                  _c("option", [_vm._v("unmatched")]),
                  _c("option", [_vm._v("ambiguous")]),
                  _c("option", [_vm._v("invalid")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Refund status")]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.refund_status,
                      expression: "filters.refund_status"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filters,
                        "refund_status",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("All")]),
                  _c("option", [_vm._v("COMPLETED")]),
                  _c("option", [_vm._v("INVALID_ACCOUNT_DETAILS")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Duplicate source reference")]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.duplicate_source_reference,
                      expression: "filters.duplicate_source_reference"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filters,
                        "duplicate_source_reference",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("All")]),
                  _c("option", { attrs: { value: "yes" } }, [_vm._v("Yes")]),
                  _c("option", { attrs: { value: "no" } }, [_vm._v("No")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-1" }, [
              _c("label", [_vm._v("Has Receipt")]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.has_receipt,
                      expression: "filters.has_receipt"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filters,
                        "has_receipt",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("All")]),
                  _c("option", { attrs: { value: "yes" } }, [_vm._v("Yes")]),
                  _c("option", { attrs: { value: "no" } }, [_vm._v("No")])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-1" },
              [
                _c("date-range-picker", {
                  attrs: {
                    "start-date": _vm.filters.start_date,
                    "end-date": _vm.filters.end_date,
                    label: _vm.trans("general.date_between")
                  },
                  on: {
                    "update:startDate": function($event) {
                      return _vm.$set(_vm.filters, "start_date", $event)
                    },
                    "update:start-date": function($event) {
                      return _vm.$set(_vm.filters, "start_date", $event)
                    },
                    "update:endDate": function($event) {
                      return _vm.$set(_vm.filters, "end_date", $event)
                    },
                    "update:end-date": function($event) {
                      return _vm.$set(_vm.filters, "end_date", $event)
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-1" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary mr-1",
                on: { click: _vm.applyFilters }
              },
              [
                _c("i", { staticClass: "feather icon-filter" }),
                _vm._v(" Apply Filters")
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                on: { click: _vm.resetFilters }
              },
              [
                _c("i", { staticClass: "feather icon-rotate-ccw" }),
                _vm._v(" Reset Filters")
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alert alert-info" }, [
        _c("strong", [_vm._v("Showing:")]),
        _vm._v(
          "\n            Institution: " +
            _vm._s(_vm.selectedInstitutionLabel) +
            ";\n            Batch: " +
            _vm._s(_vm.selectedBatchLabel) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _vm.filters.batch_id
        ? _c("div", { staticClass: "card d-print-none" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "alert alert-danger" }, [
                _vm._v(
                  "\n                    This action only targets eligible unique payments from the selected uploaded Monnify batch. It changes affected payment remarks to blank and writes a permanent audit record.\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary mr-1",
                  attrs: { disabled: _vm.loadingCorrectionPreview },
                  on: { click: _vm.loadCorrectionPreview }
                },
                [
                  _c("i", { staticClass: "feather icon-search" }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.loadingCorrectionPreview
                          ? "Loading..."
                          : "Load Correction Preview"
                      ) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary mr-1",
                  on: { click: _vm.loadCorrectionResults }
                },
                [
                  _c("i", { staticClass: "feather icon-list" }),
                  _vm._v(" Correction Results\n                ")
                ]
              ),
              _vm._v(" "),
              _vm.correctionResults.items.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary mr-1",
                      on: { click: _vm.exportCorrectionCsv }
                    },
                    [
                      _c("i", { staticClass: "feather icon-download" }),
                      _vm._v(" Results CSV\n                ")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.correctionResults.items.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-danger",
                      on: { click: _vm.exportCorrectionPdf }
                    },
                    [
                      _c("i", { staticClass: "feather icon-file-text" }),
                      _vm._v(" Results PDF\n                ")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.correctionPreview.items.length
                ? _c("div", { staticClass: "mt-2" }, [
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.correctionCards, function(card) {
                        return _c(
                          "div",
                          { key: card.label, staticClass: "col-md-3 col-sm-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "card text-center summary-card" },
                              [
                                _c("div", { staticClass: "card-body" }, [
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(card.label))
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(card.value))
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row align-items-end" }, [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("label", [_vm._v("Confirmation note")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.correctionForm.confirmation_note,
                              expression: "correctionForm.confirmation_note"
                            }
                          ],
                          staticClass: "form-control",
                          domProps: {
                            value: _vm.correctionForm.confirmation_note
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.correctionForm,
                                "confirmation_note",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" }, [
                        _c("label", [_vm._v("Confirm payment count")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.correctionForm.expected_payment_count,
                              expression:
                                "correctionForm.expected_payment_count"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: {
                            value: _vm.correctionForm.expected_payment_count
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.correctionForm,
                                "expected_payment_count",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" }, [
                        _c("label", [_vm._v("Confirm net exposure")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.correctionForm
                                  .expected_net_outstanding_exposure,
                              expression:
                                "correctionForm.expected_net_outstanding_exposure"
                            }
                          ],
                          staticClass: "form-control",
                          domProps: {
                            value:
                              _vm.correctionForm
                                .expected_net_outstanding_exposure
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.correctionForm,
                                "expected_net_outstanding_exposure",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-2" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger btn-block",
                            attrs: { disabled: !_vm.canExecuteCorrection },
                            on: { click: _vm.executeCorrection }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.executingCorrection
                                  ? "Executing..."
                                  : "Execute"
                              )
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    !_vm.correctionPreview.summary.financial_totals_consistent
                      ? _c("div", { staticClass: "alert alert-danger mt-1" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.correctionPreview.summary
                                  .financial_validation_error
                              ) +
                              "\n                    "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.canExecuteCorrection
                      ? _c("div", { staticClass: "alert alert-warning mt-1" }, [
                          _vm._v(
                            "\n                        To approve from this screen, enter a confirmation note and confirm the payment count and net exposure exactly as shown in the preview.\n                    "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-responsive mt-2" }, [
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-bordered table-sm text-nowrap"
                        },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.correctionPreview.items, function(item) {
                              return _c(
                                "tr",
                                {
                                  key:
                                    item.payment_id ||
                                    item.reconciliation_row_id
                                },
                                [
                                  _c("td", [
                                    _vm._v(_vm._s(item.payment_id || "-"))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.student_payer || "-"))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.institution || "-"))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.invoice_number || "-"))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(item.transaction_reference || "-")
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(
                                          item.expected_invoice_amount
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(
                                          item.monnify_amount_paid
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.previous_remark || "-"))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v("Blank")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        item.proposed_invoice_status || "-"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        item.replacement_payment_id || "None"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        item.replacement_transaction_reference ||
                                          "None"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(
                                          item.replacement_amount ||
                                            item.valid_replacement_amount
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.replacement_date || "-"))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        item.replacement_current_status || "-"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        item.replacement_qualification_reason ||
                                          "-"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(item.outstanding_after)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "span",
                                      {
                                        class: item.eligible
                                          ? "badge badge-success"
                                          : "badge badge-warning"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.eligible
                                              ? "Eligible"
                                              : item.exclusion_reason
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.correctionResults.items.length
                ? _c("div", { staticClass: "table-responsive mt-2" }, [
                    _c("h5", [_vm._v("Correction Results")]),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        staticClass: "table table-bordered table-sm text-nowrap"
                      },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.correctionResults.items, function(item) {
                            return _c("tr", { key: item.correction_id }, [
                              _c("td", [_vm._v(_vm._s(item.correction_id))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.execution_status))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.payment_id))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.invoice_number))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.transaction_reference))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.previous_remark || "-"))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.new_remark || "Blank"))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatMoney(item.outstanding_after)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.correction_reason || "-"))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(item.reconciled_at || "-"))
                              ])
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.cards, function(card) {
          return _c(
            "div",
            { key: card.label, staticClass: "col-md-3 col-sm-6" },
            [
              _c("div", { staticClass: "card text-center summary-card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(card.label))
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(card.value))
                  ])
                ])
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card d-print-none" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "btn-group flex-wrap" },
            _vm._l(_vm.scopes, function(scope) {
              return _c(
                "button",
                {
                  key: scope.value,
                  staticClass: "btn btn-sm",
                  class:
                    _vm.filters.scope === scope.value
                      ? "btn-primary"
                      : "btn-outline-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.setScope(scope.value)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(scope.label) +
                      "\n                    "
                  )
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(5),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _vm.rows.total
              ? _c("div", { staticClass: "table-responsive" }, [
                  _c(
                    "table",
                    {
                      staticClass: "table table-bordered table-sm text-nowrap"
                    },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.rows.data, function(row, index) {
                          return _c("tr", { key: row.id }, [
                            _c("td", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  row.payer_name ||
                                    _vm.paymentValue(row, "payer_name") ||
                                    row.source_account_name ||
                                    "-"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.institutionName(row)))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  row.invoice_reference ||
                                    _vm.paymentValue(row, "invoice_no") ||
                                    "-"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(row.transaction_reference || "-"))
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.expectedAmount(row)))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm._f("formatMoney")(row.amount_paid))
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.differenceAmount(row)))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                { staticClass: "badge badge-light-primary" },
                                [
                                  _vm._v(
                                    _vm._s(row.current_payment_status || "-")
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                {
                                  class: _vm.refundClass(
                                    row.refund_status_category
                                  )
                                },
                                [
                                  _vm._v(
                                    _vm._s(row.refund_status || "Unavailable")
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                {
                                  class: _vm.classificationClass(
                                    _vm.displayClassification(row)
                                  )
                                },
                                [_vm._v(_vm._s(_vm.displayClassification(row)))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(row.match_method)),
                              _c("br"),
                              _c("small", [_vm._v(_vm._s(row.match_status))])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  row.is_duplicate_source_reference
                                    ? row.source_reference_row_count + " rows"
                                    : "No"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "d-print-none" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "btn btn-primary btn-sm",
                                    attrs: {
                                      to: "/monnify-reconciliation/" + row.id
                                    }
                                  },
                                  [_c("i", { staticClass: "feather icon-eye" })]
                                )
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.rows.total
              ? _c("module-info", {
                  attrs: {
                    module: "report",
                    title: "module_info_title",
                    description: "module_info_description",
                    icon: "alert-triangle"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("pagination-record", {
              staticClass: "d-print-none",
              attrs: {
                "page-length": _vm.filters.page_length,
                records: _vm.rows
              },
              on: {
                "update:pageLength": function($event) {
                  return _vm.$set(_vm.filters, "page_length", $event)
                },
                "update:page-length": function($event) {
                  return _vm.$set(_vm.filters, "page_length", $event)
                },
                updateRecords: _vm.getRows
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title mb-0" }, [
        _vm._v("Selected Upload Batch")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title mb-0" }, [
        _vm._v("Upload Monnify Rejected-Payment File")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title mb-0" }, [
        _vm._v("Historical Correction Preview")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Payment ID")]),
        _c("th", [_vm._v("Student/Payer")]),
        _c("th", [_vm._v("Institution")]),
        _c("th", [_vm._v("Invoice")]),
        _c("th", [_vm._v("Rejected Transaction Ref")]),
        _c("th", [_vm._v("Expected")]),
        _c("th", [_vm._v("Monnify Paid")]),
        _c("th", [_vm._v("Previous Remark")]),
        _c("th", [_vm._v("Proposed Remark")]),
        _c("th", [_vm._v("Invoice Result")]),
        _c("th", [_vm._v("Replacement Payment ID")]),
        _c("th", [_vm._v("Replacement Transaction Ref")]),
        _c("th", [_vm._v("Replacement Amount")]),
        _c("th", [_vm._v("Replacement Date")]),
        _c("th", [_vm._v("Replacement Status")]),
        _c("th", [_vm._v("Replacement Reason")]),
        _c("th", [_vm._v("Outstanding")]),
        _c("th", [_vm._v("Eligibility")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Correction ID")]),
        _c("th", [_vm._v("Status")]),
        _c("th", [_vm._v("Payment ID")]),
        _c("th", [_vm._v("Invoice")]),
        _c("th", [_vm._v("Transaction Ref")]),
        _c("th", [_vm._v("Previous")]),
        _c("th", [_vm._v("New")]),
        _c("th", [_vm._v("Outstanding")]),
        _c("th", [_vm._v("Note")]),
        _c("th", [_vm._v("Date")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title mb-0" }, [
        _vm._v("Detailed Reconciliation Rows")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _c("th", [_vm._v("Student/Payer")]),
        _c("th", [_vm._v("Institution")]),
        _c("th", [_vm._v("Invoice number")]),
        _c("th", [_vm._v("Transaction reference")]),
        _c("th", [_vm._v("Expected amount")]),
        _c("th", [_vm._v("Amount paid")]),
        _c("th", [_vm._v("Difference")]),
        _c("th", [_vm._v("Current payment status")]),
        _c("th", [_vm._v("Refund status")]),
        _c("th", [_vm._v("Classification")]),
        _c("th", [_vm._v("Match result")]),
        _c("th", [_vm._v("Duplicate")]),
        _c("th", { staticClass: "d-print-none" }, [_vm._v("Action")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }